import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useVote } from './hooks/useVote';

import { Question } from './components/Question/Question';
import { Advt } from './components/Advt/Advt';
import { ResultQuiz } from './components/ResultQuiz/ResultQuiz';
import { MessagesList } from './components/MessagesList/MessagesList';
import { BgVideo } from './components/BgVideo/BgVideo';
import { NorthernLights } from './components/NorthernLights/NorthernLights';

import logo from './assets/images/logo.png';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, messagesRef, winnerMessage, speed } =
    useCarousel(currentState);

  const correctVar = voteState?.vars && voteState.vars.find((v) => v.correct);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.33 }}
            key={`${currentState}-question`}
            className="motionBlock"
          >
            <Question title={voteState?.title} />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.33 }}
            key={`${currentState}-advt`}
            className="motionBlock"
          >
            <Advt />
          </motion.div>
        )}

        {currentState === 'S3' && (
          <motion.div
            exit={{ y: '100vh' }}
            transition={{ duration: 0.33 }}
            key={`${correctVar?.varImgUrl}-result`}
            className="motionBlock"
          >
            <ResultQuiz correctVar={correctVar} />
          </motion.div>
        )}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <motion.div
            exit={{ y: '100vh' }}
            transition={{ duration: 0.33 }}
            key="msgs"
            className="motionBlock"
          >
            <MessagesList
              key="msgList"
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
              messagesRef={messagesRef}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <BgVideo />

      <AnimatePresence mode="wait">
        {['S3', 'S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <NorthernLights />
        )}
      </AnimatePresence>

      <div id="img-loader" />
      <img src={logo} alt="" className="preloadImg" />
    </div>
  );
}

export default App;
